<div class="d-flex align-items-center" style="height: 40px;">
  <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch" style="width: 52px;">
    <input class="custom-control-input" id="customSwitch" type="checkbox" [checked]="physical_scaaner"
      (click)="toggleVisibility($event)">
    <label class="custom-control-label" for="customSwitch">
    </label>
  </div>
  <p class="m-0">{{physical_scaaner?'Scanner':'Mobile'}}</p>
</div>

@if (physical_scaaner) {
  <label class="font-weight-bold">{{placeholderValue}}</label>
}

@if (physical_scaaner) {
  <input type="text"
    class="checkinput form-control input-element-main-search input-overlap adv-search-v2" (keypress)="onKey($event)"
    #autofocusvalue [placeholder]="placeholderValue" />
}

@if (showCameraPopUp) {
  <kx-camera-audio-permssion [device]="device" [resource]="resourceName"
  (closedevicePopup)="closedevicePopup($event)"></kx-camera-audio-permssion>
}
@if (!physical_scaaner) {
  <div id="reader"></div>
}

@if (!physical_scaaner && checkMobile() && listOfCameras.length>1) {
  <img src="assets/images/telemedicine/switch-Camera.svg" class="cursor-pointer center-btn" alt="Press to Switch Camera"
    (click)="switchCamera()">
}